var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-page" },
    [
      _c(
        "div",
        { staticClass: "viq-page__container container" },
        [
          _c("ViqSidebar"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-page__main", style: _vm.mainStyle },
            [
              _c(
                "div",
                { staticClass: "viq-page__content" },
                [
                  _c("ViqSubscriptionBar"),
                  _vm._v(" "),
                  _vm.activeLens ? _c("ViqLensIndicator") : _vm._e(),
                  _vm._v(" "),
                  !_vm.activeConversation && !_vm.isReportMode
                    ? [
                        _c(
                          "ViqWelcome",
                          [
                            _vm.showInput
                              ? _c("ViqInputArea", {
                                  attrs: { slot: "input" },
                                  slot: "input",
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : _vm.isReportMode && !_vm.activeConversation
                    ? [_c("ViqReportPanel")]
                    : [
                        _vm.isAskMode
                          ? _c("ViqChatPanel")
                          : _c("ViqReportPanel"),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _vm.showInput && (_vm.activeConversation || _vm.isReportMode)
                ? _c("ViqInputArea")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ViqSlideOut"),
      _vm._v(" "),
      _c("ViqShareDialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }